import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #00000050;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 3rem;
  overflow: visible;
  isolation: isolate;
`

export const Container = styled.div`
  width: 64rem;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: ${Tokens.ColorWhite};
  border-radius: ${Tokens.RadiusInput};
  overflow: hidden;
  position: relative;
`

export const Header = styled.div`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid ${Tokens.ColorBorder};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${Tokens.ColorWhite};
`

export const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
  margin: 0;
  flex: 1;
  text-align: center;
`

export const ContentSection = styled.div`
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-bottom: 1px solid ${Tokens.ColorBorder};
  max-height: 45vh;
  overflow-y: auto;
`

export const JustificationBanner = styled.div`
  background-color: ${Tokens.ColorUIInfoLight};
  padding: 1rem 1.25rem;
  border-radius: ${Tokens.RadiusInput};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const JustificationLabel = styled.strong`
  color: ${Tokens.ColorTextPrimary};
  font-size: 0.875rem;
  font-weight: 600;
`

export const JustificationText = styled.p`
  color: ${Tokens.ColorTextSecondary};
  line-height: 1.6;
  margin: 0;
  font-size: 0.875rem;
`

export const MentionContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1.875rem;
`

export const LogosColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.625rem;
  flex-shrink: 0;
`

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  flex: 1;
  gap: 0.5rem;
`

export const PublisherName = styled.h4`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const PublicationText = styled.span`
  color: ${Tokens.ColorTextSecondary};
  font-size: 0.875rem;
  line-height: 1.5;
  word-break: break-word;
`

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #dee2ef;
  padding: 0 2rem;
`

interface TabButtonProps {
  $active: boolean
}

export const TabButton = styled.button<TabButtonProps>`
  padding: 12px 24px;
  border: none;
  background: ${({ $active }) => ($active ? Tokens.ColorUIPrimary : 'transparent')};
  color: ${({ $active }) => ($active ? 'white' : Tokens.ColorTextSecondary)};
  border-radius: 8px 8px 0 0;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $active }) => ($active ? Tokens.ColorUIPrimary : Tokens.ColorHover)};
  }

  &:focus {
    outline: none;
  }
`

export const TabContent = styled.div`
  padding: 1.5rem 2rem;
  background-color: ${Tokens.ColorWhite};
  overflow-y: auto;
  max-height: 30vh;
  display: flex;
  flex-direction: column;
`

export const LoadingText = styled.p`
  color: ${Tokens.ColorTextSecondary};
  text-align: center;
  margin: 2rem 0;
`

export const JustificationTextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 1rem;
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: ${Tokens.RadiusInput};
  font-size: 0.875rem;
  line-height: 1.6;
  color: ${Tokens.ColorTextPrimary};
  resize: vertical;
  font-family: inherit;
  background-color: ${Tokens.ColorBackgroundSecondary};

  &:focus {
    outline: none;
    border-color: ${Tokens.ColorUIPrimary};
  }

  &::placeholder {
    color: ${Tokens.ColorTextTertiary};
  }
`

export const Footer = styled.div`
  padding: 1.5rem 2rem;
  border-top: 1px solid ${Tokens.ColorBorder};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: ${Tokens.ColorWhite};
`
